import ModalDialog from "../Modal/Modal";
import Stack from "../Utils/Stack.styled";
import Title from "../Utils/Title.styled";
import Paragraph from "../Utils/Paragraph.styled";
import Button from "../Button";
import CONSTANT from "../../constants/constant";

const MessageModal = ({
  title,
  message,
  onClose,
  showConfirmButton = false,
  onClick,
}) => {
  const onClickButton = (key) => {
    onClick(key);
  };
  return (
    <ModalDialog isOpen onClose={onClose}>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        height="100%"
        gap="32"
        padding="16px"
      >
        <Title size="28px" height="100%">
          {title}
        </Title>
        <Paragraph size="18px">{message}</Paragraph>
        {showConfirmButton && (
          <Stack direction="row" justifyContent="center" gap="24">
            <Button
              padding="12px 24px"
              label={CONSTANT.LABEL.CANCEL}
              onClick={() => onClickButton(CONSTANT.LABEL.CANCEL)}
            ></Button>
            <Button
              padding="12px 24px"
              label={CONSTANT.LABEL.CONFIRM}
              onClick={() => onClickButton(CONSTANT.LABEL.CONFIRM)}
            ></Button>
          </Stack>
        )}
      </Stack>
    </ModalDialog>
  );
};

export default MessageModal;
